import PropTypes from 'prop-types';
import React from 'react';
import { get, isEmpty } from 'lodash';
import classNames from 'classnames';
import {
  Avatar,
  Arrays,
  Addresses,
  Icon,
} from '@unite-us/app-components';

const ServiceProviderListItem = ({ provider, isSelected }) => {
  const itemClass = () => classNames({
    'service-provider-list-item': true,
    selected: isSelected,
  });
  const address = get(provider, 'addresses[0]');
  const phoneNumber = Arrays.findPrimaryOrFirst(get(provider, 'phone_numbers', []));

  return (
    <div className={itemClass()}>
      <div className="service-provider-list-item__avatar">
        <Avatar
          image={get(provider, 'logo_url')}
          size="sm"
          alt={`${provider.name} avatar`}
          fallbackIcon="Electrons"
        />
      </div>
      <div className="service-provider-list-item__body">
        <h3>{provider.name}</h3>
        {!isEmpty(address) && (
          <div className="address-text">
            <Icon icon="MapPin" className="mr-1" />
            <span>{Addresses.getAddressString(address)}</span>
          </div>
        )}
        {!isEmpty(phoneNumber) && (
          <div className="phone-number-display">
            <Icon icon="Phone" className="mr-1" />
            <span>{get(phoneNumber, 'phone_number')}</span>
          </div>
        )}
        {!isEmpty(get(provider, 'website_url')) && (
          <div className="website-url">
            <Icon icon="Globe" className="mr-1" />
            <span>{provider.website_url}</span>
          </div>
        )}
      </div>
    </div>
  );
};

ServiceProviderListItem.propTypes = {
  provider: PropTypes.shape({
    name: PropTypes.string,
    website_url: PropTypes.string,
  }).isRequired,
  isSelected: PropTypes.bool,
};

ServiceProviderListItem.defaultProps = {
  isSelected: false,
};

export default ServiceProviderListItem;
